const state = {
  config: null,
};

const mutations = {
  SET_CONFIG(state, config) {
    state.config = config;
  },
};

const actions = {
  
  downloadConfig({ commit, rootState }) {
    rootState.Database.db
      .collection("common")
      .doc("app")
      .get()
      .then(doc => {
        commit("SET_CONFIG", doc.data());
      });
  },
};

const getters = {
  getConfig(state) {
    return state.config;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 



// WEBPACK FOOTER //
// ./src/store/modules/Config.js